export default __webpack_public_path__ + "static/media/kenyatta.9c375bab.jpg";